// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlayCircleFilledSvg from "@fishx/icons-svg/es/asn/PlayCircleFilled";
import FishxIcon from '../components/FishxIcon';

var PlayCircleFilled = function PlayCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlayCircleFilledSvg
  }));
};

PlayCircleFilled.displayName = 'PlayCircleFilled';
export default React.forwardRef(PlayCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PlayCircleFilled.js
// module id = 3797
// module chunks = 0